import { Skeleton, Row, Col } from "antd";

const LoadSkeleton = ({ rowProps, colProps }) => (
  <Row {...rowProps}>
    <Col {...colProps} span={24}>
      <Skeleton loading active />
    </Col>
  </Row>
);

export default LoadSkeleton;
